// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2ugaL","checkboxCol":"Table_checkboxCol__3y4k-","emailCol":"Table_emailCol__2h9Aq","actionCol":"Table_actionCol__2qu6c"};